<template lang="html">
  <chart :chartData="currentDataChart" :options="options" v-if="currentDataChart !== undefined"></chart>
  <spinner v-else></spinner>
</template>

<script>
import Chart from '@/pages/statistics/components/graphiques/BarChart.vue'
import Spinner from '@/components/common/spinner.vue'
import * as R from 'ramda'
import {statusLabel} from '@/helpers/labels'

export default {
  props: ['showAmountNotNumber', 'chartData'],
  data () {
    return {
      options: undefined
    }
  },
  components: {
    'chart': Chart,
    'spinner': Spinner
  },
  created () {
    this.options = {
      responsive: true,
      scales: {
        yAxes: [{
          ticks: {
            min: 0,
            stepSize: 200,
            beginAtZero: true
          }
        }]
      },
      legend: {
        display: false,
        fullWidth: false,
        align: 'start'
      }
    }
  },
  computed: {
    currentDataChart () {
      if (this.chartData !== undefined) {
        return this.makeChartData(this.chartData)
      }
    }
  },
  watch: {
    showAmountNotNumber: {
      handler () {
        if (this.$engine.monitoring.graphByStatus !== undefined) {
          this.chartData = this.makeChartData(this.$engine.monitoring.graphByStatus)
        }
      }
    }
  },
  methods: {
    makeChartData (rawData) {
      let data = {
        labels: [],
        datasets: []
      }
      // Status not to merge, label changing according to the direction
      let NotMergeStatus = ['Doc_1', 'Doc_2', 'Doc_10', 'Doc_11']
      // role sender status labels
      let creditorKeys = R.keys(rawData.creditor)
      for (let key in creditorKeys) {
        data.labels.push(statusLabel(this.$i18n, creditorKeys[key], '0'))
      }
      // role reciever status label
      let debtorKeys = R.keys(rawData.debtor)
      for (let key in debtorKeys) {
        if (!data.labels.includes(statusLabel(this.$i18n, debtorKeys[key], '1'))) {
          data.labels.push(statusLabel(this.$i18n, debtorKeys[key], '1'))
        }
      }
      // prepare datasets
      let dataCred = {data: [], label: '', backgroundColor: [], borderColor: []}
      // add creditor dataset
      for (let credStatus in rawData.creditor) {
        if (credStatus) {
          dataCred.data = R.append(rawData.creditor[credStatus].amount, dataCred.data)
        }
      }
      // add debtor dataset
      for (let debStatus in rawData.debtor) {
        if (creditorKeys.find(item => item === debStatus) && !NotMergeStatus.includes(debStatus)) {
          dataCred.data[creditorKeys.indexOf(debStatus)] = parseInt(dataCred.data[creditorKeys.indexOf(debStatus)]) + parseInt(rawData.debtor[debStatus].amount)
        } else {
          dataCred.data = R.append(rawData.debtor[debStatus].amount, dataCred.data)
        }
      }

      // graph label and colors
      dataCred.label = this.$i18n.t('graph.rcvd')
      dataCred.backgroundColor = [
        'rgba(125, 207, 164, 0.8)',
        'rgba(106, 200, 151, 0.8)',
        'rgba(87, 193, 138, 0.8)',
        'rgba(69, 186, 126, 0.8)',
        'rgba(62, 168, 113, 0.8)',
        'rgba(55, 149, 100, 0.8)',
        'rgba(48, 130, 88, 0.8)',
        'rgba(41, 120, 76, 0.8)',
        'rgba(125, 207, 164, 0.8)',
        'rgba(106, 200, 151, 0.8)',
        'rgba(87, 193, 138, 0.8)',
        'rgba(69, 186, 126, 0.8)',
        'rgba(62, 168, 113, 0.8)',
        'rgba(55, 149, 100, 0.8)',
        'rgba(48, 130, 88, 0.8)',
        'rgba(41, 120, 76, 0.8)'
      ]
      dataCred.borderColor = [
        'rgba(125, 207, 164, 0.8)',
        'rgba(106, 200, 151, 0.8)',
        'rgba(87, 193, 138, 0.8)',
        'rgba(69, 186, 126, 0.8)',
        'rgba(62, 168, 113, 0.8)',
        'rgba(55, 149, 100, 0.8)',
        'rgba(48, 130, 88, 0.8)',
        'rgba(125, 207, 164, 0.8)',
        'rgba(106, 200, 151, 0.8)',
        'rgba(87, 193, 138, 0.8)',
        'rgba(69, 186, 126, 0.8)',
        'rgba(62, 168, 113, 0.8)',
        'rgba(55, 149, 100, 0.8)',
        'rgba(48, 130, 88, 0.8)'
      ]

      data.datasets = [dataCred]
      return data
    }
  }
}
</script>



// WEBPACK FOOTER //
// GraphByStatus.vue?ec594fb0